import { createContext } from 'react';

import { SelectedAnnouncementContextProps } from './SelectedAnnouncementContext.types';

export const SelectedAnnouncementContext = createContext<SelectedAnnouncementContextProps | undefined>(undefined);
